import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonUtil } from '../../util/common-util';
import { Constant } from '../../constant';

@Component({
    selector: 'app-survey-answer-reminder-dialog',
    templateUrl: './survey-answer-reminder-dialog.component.html',
    styleUrl: './survey-answer-reminder-dialog.component.css',
    standalone: true,
    imports: [
      MatDialogModule,
      MatButtonModule,
    ]
})
export class SurveyAnswerReminderDialogComponent {
  public month: number;
  public safeHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<SurveyAnswerReminderDialogComponent>,
    private commonUtil: CommonUtil,
    private domSanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: { month: number }
  ) {
    this.month = data.month;
    this.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(`${this.month}${Constant.msgSurveyAnswerReminderSuffix}`);
  }

  onAnswer(): void {
    if (!this.commonUtil.checkOnline()) {
      return;
    }
    this.dialogRef.close(true);
  }
}
